export default __webpack_public_path__ + "static/media/237.c345bf6f.png";